.k{justify-content:center;}